import { motion } from "framer-motion";
import { Flame, Fish, UtensilsCrossed, Coffee, Store } from "lucide-react";
import { SECTORS } from "../lib/site";

const ICONS = { Flame, Fish, UtensilsCrossed, Coffee, Store };

export default function Sectors() {
  return (
    <section data-testid="sectors-section" className="relative py-24 lg:py-32 bg-[#12141c] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <div className="max-w-xl">
            <p className="eyebrow mb-5">Who it's built for</p>
            <h2 data-testid="sectors-headline" className="font-display font-semibold text-white tracking-tight leading-[1.05] text-3xl sm:text-5xl">
              Tailored for every <span className="italic text-amber-500">food counter.</span>
            </h2>
          </div>
          <p className="text-gray-400 text-base max-w-sm leading-relaxed">
            From late-night kebab rushes to Friday chippy queues — configured for how your shop actually works.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {SECTORS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.name}
                data-testid={`sector-card-${i}`}
                className="group rounded-2xl bg-[#0b0c10] border border-amber-500/15 hover:border-amber-500/50 p-6 transition-colors duration-300"
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: 0.07 * i, duration: 0.6 }}
              >
                <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-amber-500/10 border border-amber-500/25 text-amber-400">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-white">{s.name}</h3>
                <p className="mt-2 text-sm text-gray-500 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
